import DbConfig from '../../../config/DbConfig.js'
import {formatTimeToYMDHms,socketType2DbType,rtrim} from '../../functions/Common.js'

/**
 * 获取本地最近聊天列表
 * @param {Object} open_id
 * @param {Object} type
 * @param {Object} lastTime
 * @param {Object} callback
 */
export function getRecentlyList(open_id,type,lastTime,callback){
	// 普通类型
	let normal_types = ['all','friends','cluster','collection','no_read','no_reply']
	// 常规的消息处理
	if(normal_types.indexOf(type) !== -1){
		getRecentlyListNormal(open_id,type,lastTime,callback)
	}
	// 涉及到分组的处理
	else{
		getRecentlyListGroup(open_id,type,lastTime,callback)
	}
}

// 获取本地最近聊天列表-常规类型的处理
function getRecentlyListNormal(open_id,type,lastTime,callback){
	let limit = 20
	let db = DbConfig.connect()
	let sql = 'select * from yswl_recently where'
	// 其他条件刷选
	// 客服wxid过滤
	if(open_id !== ''){
		sql += ' account_open_id = "'+ open_id +'" and'
	}
	// 聊天类型过滤
	let chat_type = 0
	if(type == 'friends'){
		chat_type = 1
	}else if(type == 'cluster'){
		chat_type = 2
	}else if(type == 'collection'){
		sql += ' is_collect = 1 and'
	}else if(type == 'no_read'){
		sql += ' no_read_num > 0 and'
	}else if(type == 'no_reply'){
		sql += ' is_me = 0 and'
	}
	if(chat_type > 0){
		sql += ' chat_type = '+ chat_type + ' and'
	}
	// 第一次获取全部置顶的消息
	if(lastTime === 0){
		sql += ' is_top = 1 and'
		sql = rtrim(rtrim(sql,'and'),'where') + ' order by last_modified_time desc'
		db.transaction(tx=>{
			// 先查询置顶的
			tx.executeSql(sql,[],(tx,results)=>{ 
				let list = []
				for(let i = 0;i < results.rows.length;i++){
					list.push(results.rows[i])
				}
				sql = sql.replace('is_top = 1','(is_top <> 1 or is_top is null)') + ' limit ' + limit
				// 再查询20条不置顶的
				tx.executeSql(sql,[],(tx,results2)=>{
					for(let i = 0;i < results2.rows.length;i++){
						list.push(results2.rows[i])
					}
					callback(list)
				})
			})
		})
	}else{
		sql += ' (is_top <> 1 or is_top is null) and'
		if(lastTime > 0){
			sql += ' last_modified_time < ' + lastTime + ' and'
		}
		sql = rtrim(rtrim(sql,'and'),'where')
		sql += ' order by last_modified_time desc limit ' +limit
		db.transaction(tx=>{
			tx.executeSql(sql,[],(tx,results)=>{ 
				let list = []
				for(let i = 0;i < results.rows.length;i++){
					list.push(results.rows[i])
				}
				callback(list)
			})
		})
	}
}

// 获取本地最近聊天列表-常规类型的处理
function getRecentlyListGroup(open_id,type,lastTime,callback){
	let list = []
	let v_type = type.split('_')
	let group_id = parseInt(v_type[v_type.length-1])
	if(group_id === 0){
		callback(list)
		return
	}
	let limit = 20
	let db = DbConfig.connect()
	let sql = 'select r.* from yswl_recently as r inner join yswl_friend_group_rel as gr on r.id=gr.chatting_id where'
	// 其他条件刷选
	// 客服wxid过滤
	if(open_id !== ''){
		sql += ' r.account_open_id = "'+ open_id +'" and'
	}
	// 聊天类型过滤
	sql += ' gr.group_id = '+group_id+' and gr.client_type = 1 and '
	// 第一次获取全部置顶的消息
	if(lastTime === 0){
		sql += ' is_top = 1 and'
		sql = rtrim(rtrim(sql,'and'),'where') + ' order by last_modified_time desc'
		db.transaction(tx=>{
			// 先查询置顶的
			tx.executeSql(sql,[],(tx,results)=>{ 
				let list = []
				for(let i = 0;i < results.rows.length;i++){
					list.push(results.rows[i])
				}
				sql = sql.replace('is_top = 1','(is_top <> 1 or is_top is null)') + ' limit ' + limit
				// 再查询20条不置顶的
				tx.executeSql(sql,[],(tx,results2)=>{
					for(let i = 0;i < results2.rows.length;i++){
						list.push(results2.rows[i])
					}
					callback(list)
				})
			})
		})
	}else{
		sql += ' (is_top <> 1 or is_top is null) and'
		if(lastTime > 0){
			sql += ' last_modified_time < ' + lastTime + ' and'
		}
		sql = rtrim(rtrim(sql,'and'),'where')
		sql += ' order by last_modified_time desc limit ' +limit
		db.transaction(tx=>{
			tx.executeSql(sql,[],(tx,results)=>{ 
				let list = []
				for(let i = 0;i < results.rows.length;i++){
					list.push(results.rows[i])
				}
				callback(list)
			})
		})
	}
}


// 获取本地最近聊天列表
export function getRecentlyById(id,callback){
	let db = DbConfig.connect()
	let sql = 'select * from yswl_recently where id = '+ id
	db.transaction(tx=>{
		tx.executeSql(sql,[],(tx,results)=>{ 
			if(results.rows.length == 0){
				callback(false)
			}else{
				callback(results.rows[0])
			}
		})
	})
}

/**
 * @param {Object} data 录入的数据
 * @param {Object} callback 回调函数
 */
export function saveRecently(data,callback){
	let id = data.id === undefined ? 0 : data.id
	let account_open_id = data.account_open_id === undefined ? '' : data.account_open_id
	let friends_open_id = data.friends_open_id === undefined ? '' : data.friends_open_id
	let friend_or_cluster_id = data.friend_or_cluster_id === undefined ? '' : data.friend_or_cluster_id
	let friend_img = data.friend_img === undefined ? '' : data.friend_img
	let friend_name = data.friend_name === undefined ? '' : data.friend_name
	let chat_type = data.chat_type === undefined ? 1 : data.chat_type
	let last_chat_msg = data.last_chat_msg === undefined ? '' : data.last_chat_msg
	let last_chat_msg_type = data.last_chat_msg_type === undefined ? '' : socketType2DbType(data.last_chat_msg_type)
	let last_modified_time = data.last_modified_time === undefined ? 0 : data.last_modified_time
	let is_new = data.is_new === undefined ? 0 : data.is_new
	let is_me = data.is_me === undefined ? 0 : data.is_me
	if(id === 0){
		callback(false)
		return
	}
	localStorage.setItem('yswl_sync_time',new Date().getTime())
	// 判断当前id的记录是否存在，存在则更新，不存在则添加
	let db = DbConfig.connect()
	getRecentlyById(id,(data2)=>{
		// 更新
		if(data2){
			data.is_top = data2.is_top
			data.is_collect = data2.is_collect
			data.no_disturb = data2.no_disturb
			data.is_transfer = data2.is_transfer
			if(data.msgToUp !== undefined && data.msgToUp === 0){
				last_modified_time = data2.last_modified_time
			}
			db.transaction(tx=>{
				if(is_me == 1){
					let sql = 'update yswl_recently set last_chat_msg=?,last_chat_msg_type=?,last_modified_time=?,is_me=? where id=?'
					tx.executeSql(sql,[last_chat_msg,last_chat_msg_type,last_modified_time,is_me,data2.id],(tx,results)=>{ 
						data['no_read_num'] = data2.no_read_num
						callback(data)
					},(tx,error)=>{
						console.log(error)
					})
				}else{
					let sql = 'update yswl_recently set last_chat_msg=?,last_chat_msg_type=?,last_modified_time=?,no_read_num=no_read_num+1,is_me=? where id=?'
					tx.executeSql(sql,[last_chat_msg,last_chat_msg_type,last_modified_time,is_me,data2.id],(tx,results)=>{ 
						data['no_read_num'] = data2.no_read_num+1
						callback(data)
					},(tx,error)=>{
						console.log(error)
					})
				}
			})
		}
		// 添加
		else{
			data.is_top = 0
			data.is_collect = 0
			data.no_disturb = 0
			db.transaction(tx=>{
				if(is_me == 1){
					let no_read_num = 0
					if(last_chat_msg === '我通过了你的朋友验证请求，现在我们可以开始聊天了'){
						no_read_num = 1
					}
					let sql = 'insert into yswl_recently(id,account_open_id,friends_open_id,friend_or_cluster_id,friend_img,friend_name,chat_type,last_chat_msg,last_chat_msg_type,last_modified_time,is_new,is_top,is_collect,no_read_num,is_me)'+
							  'values(?,?,?,?,?,?,?,?,?,?,?,?,?,?,?)'
					tx.executeSql(sql,[id,account_open_id,friends_open_id,friend_or_cluster_id,friend_img,friend_name,chat_type,last_chat_msg,last_chat_msg_type,last_modified_time,is_new,0,0,no_read_num,is_me],(tx,results)=>{ 
						data['no_read_num'] = no_read_num
						callback(data)
					},(tx,error)=>{
						console.log(error)
					})
				}else{
					let sql = 'insert into yswl_recently(id,account_open_id,friends_open_id,friend_or_cluster_id,friend_img,friend_name,chat_type,last_chat_msg,last_chat_msg_type,last_modified_time,is_new,is_top,is_collect,no_read_num,is_me)'+
							  'values(?,?,?,?,?,?,?,?,?,?,?,?,?,?,?)'
					tx.executeSql(sql,[id,account_open_id,friends_open_id,friend_or_cluster_id,friend_img,friend_name,chat_type,last_chat_msg,last_chat_msg_type,last_modified_time,is_new,0,0,1,is_me],(tx,results)=>{ 
						data['no_read_num'] = 1
						callback(data)
					},(tx,error)=>{
						console.log(error)
					})
				}
			})
		}
	})
}


// 修改最近聊天表中的未读消息数量
export function updateNumRecentlyById(id,num,callback){
	let db = DbConfig.connect()
	let sql = 'update yswl_recently set no_read_num = ? where id=?'
	db.transaction(tx=>{
		tx.executeSql(sql,[parseInt(num),id],(tx,results)=>{ 
			callback()
		})
	})
}

// 根据粉丝id或者群id，类型，获取记录
export function getRecentlyByFIdAndType(f_id,chat_type,callback){
	let db = DbConfig.connect()
	let sql = 'select * from yswl_recently where friend_or_cluster_id = ? and chat_type = ?'
	db.transaction(tx=>{
		tx.executeSql(sql,[f_id,chat_type],(tx,results)=>{ 
			if(results.rows.length == 0){
				callback(false)
			}else{
				callback(results.rows[0])
			}
		})
	})
}

// 根据粉丝id或者群id，类型，删除记录
export function deleteRecentlyByFIdAndType(f_id,chat_type,callback){
	let db = DbConfig.connect()
	let sql = 'delete from yswl_recently where friend_or_cluster_id = ? and chat_type = ?'
	db.transaction(tx=>{
		tx.executeSql(sql,[f_id,chat_type],(tx,results)=>{ 
			callback(true)
		},(tx,error)=>{
			callback(false)
		})
	})
}

// 根据粉丝id或者群id，类型，更新记录
export function updateRecentlyByFIdAndType(f_id,chat_type,param,callback){
	let db = DbConfig.connect()
	let friend_name = ''
	let sql = 'update yswl_recently'
	// 修改群名时用到
	if(param.cluster_name !== undefined){
		sql += ' set friend_name = "' + param.cluster_name + '",'
	}
	// 修改备注时用到
	if(param.friend_name !== undefined){
		sql += ' set friend_name = "' + param.friend_name + '",'
	}
	if(param.last_modified_time !== undefined){
		sql += ' set last_modified_time = ' + param.last_modified_time + ','
	}
	sql = rtrim(sql,',')
	sql += ' where friend_or_cluster_id = ? and chat_type = ?'
	if(sql.indexOf('set') === -1){
		callback(false)
		return
	}
	db.transaction(tx=>{
		tx.executeSql(sql,[f_id,chat_type],(tx,results)=>{ 
			callback(true)
		},(tx,error)=>{
			callback(false)
		})
	})
}

// 根据id，更新记录
export function updateRecentlyById(id,param,callback){
	let db = DbConfig.connect()
	let friend_name = ''
	let sql = 'update yswl_recently'
	// 修改收藏时
	if(param.is_collect !== undefined){
		sql += ' set is_collect = ' + param.is_collect + ','
	}
	// 修改置顶时
	if(param.is_top !== undefined){
		sql += ' set is_top = "' + param.is_top + '",'
	}
	// 修改免打扰时
	if(param.no_disturb !== undefined){
		sql += ' set no_disturb = "' + param.no_disturb + '",'
	}
	sql = rtrim(sql,',')
	sql += ' where id = ?'
	if(sql.indexOf('set') === -1){
		callback(false)
		return
	}
	db.transaction(tx=>{
		tx.executeSql(sql,[id],(tx,results)=>{ 
			callback(true)
		},(tx,error)=>{
			callback(false)
		})
	})
}

// 根据id，删除本地记录
export function delRecentlyById(id,callback){
	let db = DbConfig.connect()
	let sql = 'delete from yswl_recently where id = ?'
	db.transaction(tx=>{
		tx.executeSql(sql,[id],(tx,results)=>{ 
			callback(true)
		})
	})
}

// 获取本地所有的客服未读消息数
export function getRecentlyNoReadCount(wxid,callback){
	let db = DbConfig.connect()
	let sql = 'SELECT account_open_id,SUM(no_read_num) as no_read_total FROM yswl_recently GROUP BY account_open_id'
	if(wxid !== ''){
		sql = 'SELECT account_open_id,SUM(no_read_num) as no_read_total FROM yswl_recently where account_open_id = "'+ wxid +'" GROUP BY account_open_id'
	}
	db.transaction(tx=>{
		tx.executeSql(sql,[],(tx,results)=>{ 
			let list = {}
			for(let i = 0;i < results.rows.length;i++){
				list[results.rows[i].account_open_id] = results.rows[i]
			}
			callback(list)
		})
	})
}

// 获取本地所有的客服未读消息数-只有一个总数
export function getRecentlyNoReadAll(callback){
	let db = DbConfig.connect()
	let sql = 'SELECT SUM(no_read_num) as no_read_total FROM yswl_recently'
	db.transaction(tx=>{
		tx.executeSql(sql,[],(tx,results)=>{ 
			let count = 0
			for(let i = 0;i < results.rows.length;i++){
				count = results.rows[i].no_read_total
				break
			}
			callback(count)
		})
	})
}